// extracted by mini-css-extract-plugin
module.exports = {"pageWrapper":"Page_pageWrapper__yH3qv"};